import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { AmendmentDetailState, AmendmentDetailReducer, ACTION_TYPES, initialDrawers } from './amendment-detail-reducer';
export { ACTION_TYPES };

const AmendmentDetailContext = createContext<AmendmentDetailState | undefined>(undefined);
const AmendmentDetailDispatchContext = createContext({} as any);

export const AmendmentDetailProvider = ({ children }: { children: React.ReactNode }) => {
    const { amendmentId } = useParams();
    const initialState: AmendmentDetailState = {
        amendmentId: amendmentId!,
        parlamentarians: [],
        politicalParties: [],
        suppliers: [],
        tabIndex: 0,
        commitments: [],
        liquidations: [],
        payments: [],
        transfers: [],
        accountReports: [],
        attachments: [],
        ...initialDrawers,
    };
    const [state, dispatch] = useReducer(AmendmentDetailReducer, initialState);
    return (
        <AmendmentDetailContext.Provider value={state}>
            <AmendmentDetailDispatchContext.Provider value={dispatch}>
                {children}
            </AmendmentDetailDispatchContext.Provider>
        </AmendmentDetailContext.Provider>
    );
};

export const useAmendmentDetailState = () => {
    const context = useContext(AmendmentDetailContext);
    if (!context) throw new Error('useAmendmentDetailState must be used within AmendmentDetailProvider');
    return context;
};

export const useAmendmentDetailDispatch = () => {
    const context = useContext(AmendmentDetailDispatchContext);
    if (!context) throw new Error('useAmendmentDetailDispatch must be used within AmendmentDetailProvider');
    return context;
};
